import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const portfolioImages = [
  {
    url: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80',
    category: 'Wedding',
    title: 'Wedding Moments',
    span: 'md:col-span-2 md:row-span-2',
  },
  {
    url: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=600&q=80',
    category: 'Wedding',
    title: 'Ceremony',
    span: 'md:row-span-2',
  },
  {
    url: 'https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=600&q=80',
    category: 'Event',
    title: 'Business Event',
    span: '',
  },
  {
    url: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&q=80',
    category: 'Event',
    title: 'Conference',
    span: '',
  },
  {
    url: 'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=800&q=80',
    category: 'Content',
    title: 'Social Media',
    span: 'md:col-span-2',
  },
];

const Portfolio = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="portfolio"
      className="py-24 md:py-32 bg-cream"
      data-testid="portfolio-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 md:mb-20"
        >
          <p className="font-sans text-xs tracking-superwide text-terracotta mb-4">
            OUR WORK
          </p>
          <h2 className="font-serif text-4xl sm:text-5xl text-charcoal">
            Featured Portfolio
          </h2>
        </motion.div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {portfolioImages.map((image, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`relative group overflow-hidden ${image.span}`}
              data-testid={`portfolio-item-${index}`}
            >
              <div className="aspect-[4/5] md:aspect-auto md:h-full min-h-[300px]">
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-charcoal/0 group-hover:bg-charcoal/60 transition-all duration-500 flex items-end p-6">
                  <div className="translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                    <p className="font-sans text-xs tracking-widest text-terracotta mb-2">
                      {image.category.toUpperCase()}
                    </p>
                    <p className="font-serif text-xl text-cream">
                      {image.title}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-center mt-12"
        >
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-block font-sans text-xs tracking-widest border border-charcoal text-charcoal px-8 py-4 hover:bg-charcoal hover:text-cream transition-all duration-300"
            data-testid="portfolio-cta"
          >
            VIEW FULL PORTFOLIO
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Portfolio;
